import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Slide,
  TextField
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useFormik } from 'formik'
import moment from 'moment'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import UserServices from '../../../../../Services/Consumers/UserServices'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const EditCompanySubscription = ({
  index, data, setData, handleNotificationCall,
  handleEditSubscriptionDialog, viewEditSubscriptionDialog, openEditSubscriptionDialog
}) => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  const intl = useIntl()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subscription_end_date: data[index]?.subscription_end_date
        ? moment(data[index].subscription_end_date).format('YYYY-MM-DD')
        : ''
    },
    validate: values => {
      const errors = {}
      if (!values.subscription_end_date) {
        errors.subscription_end_date = intl.formatMessage({ id: 'Fields.required' })
      }
      return errors
    },
    onSubmit: (values, actions) => {
      if (!keycloak?.authenticated) return
      UserServices.updateCompanySubscription(
        data[index].id,
        { subscription_end_date: values.subscription_end_date },
        { headers: { Authorization: `Bearer ${keycloak?.token ?? ''}` } },
        null,
        actions
      ).then(result => {
        if (!result || result.status !== 200) {
          actions.setSubmitting(false)
        } else {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'Companies.EditSubscription.Success' }),
            color: 'success'
          }, 'success')
          setData(prev => prev.map((item, i) => i === index ? result.data.data : item))
          handleEditSubscriptionDialog()
        }
      }).catch(() => {
        actions.setSubmitting(false)
      })
    }
  })

  return (
    <>
      {!!viewEditSubscriptionDialog &&
      <Dialog
        keepMounted
        fullWidth
        maxWidth={'sm'}
        open={openEditSubscriptionDialog}
        classes={{ paper: classes.NewOrderDialogPaper }}
        TransitionComponent={Transition}
        onClose={handleEditSubscriptionDialog}
        aria-labelledby="EditSubscriptionDialog"
        aria-describedby="EditSubscriptionDialog"
      >
        <IconButton
          edge={false}
          className={classes.NewOrderDialogClose}
          color="inherit"
          aria-label="close dialog"
          onClick={handleEditSubscriptionDialog}
        >
          <CloseIcon/>
        </IconButton>
        <DialogContent className={classes.NewOrderDialogContent}>
          {!!formik.isSubmitting && <FormLoader loading={true}/>}
          <Box px={4} pt={4} pb={2}>
            <p className={classes.DialogTitle}>
              <FormattedMessage id='Companies.EditSubscription.DialogTitle'/>
            </p>
            <form onSubmit={formik.handleSubmit} noValidate autoComplete="off">
              <TextField
                fullWidth
                id="subscription_end_date"
                label={intl.formatMessage({ id: 'Companies.EditSubscription.SubscriptionEndDate' })}
                type="date"
                margin="dense"
                variant="outlined"
                name="subscription_end_date"
                value={formik.values.subscription_end_date}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                helperText={formik.errors.subscription_end_date && formik.touched.subscription_end_date && formik.errors.subscription_end_date}
                error={!!(formik.errors.subscription_end_date && formik.touched.subscription_end_date)}
              />
            </form>
          </Box>
        </DialogContent>
        <DialogActions className={classes.NewOrderDialogFooter}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting || !formik.isValid}
            onClick={formik.submitForm}
          >
            <FormattedMessage id='AdditionalInfo.button.submit'/>
          </Button>
          <Button onClick={handleEditSubscriptionDialog} color="primary">
            <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
          </Button>
        </DialogActions>
      </Dialog>
      }
    </>
  )
}

export default EditCompanySubscription
